import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row fv-row mb-5 mt-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col" })
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_6 = { class: "col-12 pt-5" }
const _hoisted_7 = { class: "d-grid gap-2 d-md-flex justify-content-md-end" }
const _hoisted_8 = { class: "d-flex px-8" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex mx-9 position-relative"
}
const _hoisted_10 = { class: "d-flex px-2" }
const _hoisted_11 = {
  key: 0,
  class: "card-header border-0"
}
const _hoisted_12 = { class: "card-toolbar" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-2" }
const _hoisted_15 = { class: "col-2" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "col-3" }
const _hoisted_19 = { class: "col-2" }
const _hoisted_20 = { class: "card-body py-3" }
const _hoisted_21 = { class: "table-responsive" }
const _hoisted_22 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_23 = {
  key: 0,
  class: "fw-bolder text-muted bg-light"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"25%"}
}, "Nama", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"10%"}
}, " Nomor Identitas ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"12%"}
}, "Kelas", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"13%"}
}, " Kelas Detail ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"25%"}
}, " Status ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"15%"}
}, "Tags", -1)
const _hoisted_30 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "fw-bolder text-muted bg-light"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"20%"}
}, "Nama", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"10%"}
}, " Nomor Identitas ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"12%"}
}, "Kelas", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"13%"}
}, " Kelas Detail ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"20%"}
}, " Status ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"10%"}
}, "Tags", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-125px; text-center",
  style: {"width":"15%"}
}, "Aksi", -1)
const _hoisted_39 = [
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_47 = {
  key: 1,
  class: "badge badge-info"
}
const _hoisted_48 = {
  key: 2,
  class: "badge badge-warning"
}
const _hoisted_49 = {
  key: 3,
  class: "badge badge-danger"
}
const _hoisted_50 = {
  key: 4,
  class: "badge badge-success"
}
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = { class: "text-center" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { class: "row mt-5 mb-5" }
const _hoisted_69 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_70 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_71 = ["label", "value"]
const _hoisted_72 = { class: "p-3" }
const _hoisted_73 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_74 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_UploadModal = _resolveComponent("UploadModal")!
  const _component_DaftarPSP = _resolveComponent("DaftarPSP")!
  const _component_DownloadSekolah = _resolveComponent("DownloadSekolah")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (
                _ctx.role !== 'SALES_LEADER' &&
                _ctx.role !== 'SALES_AREA' &&
                _ctx.role !== 'CS_LEADER' &&
                _ctx.role !== 'CS_MEMBER' &&
                _ctx.role !== 'MARKETING_LEADER' &&
                _ctx.role !== 'MARKETING_MEMBER' &&
                _ctx.role !== 'ADMIN_FINANCE'
              )
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/superadmin/siswa/add'))),
                    class: "btn btn-info"
                  }, " Tambah Data "))
                : _createCommentVNode("", true),
              (
                _ctx.role !== 'SALES_LEADER' &&
                _ctx.role !== 'SALES_AREA' &&
                _ctx.role !== 'CS_LEADER' &&
                _ctx.role !== 'CS_MEMBER' &&
                _ctx.role !== 'MARKETING_LEADER' &&
                _ctx.role !== 'MARKETING_MEMBER' &&
                _ctx.role !== 'ADMIN_FINANCE'
              )
                ? (_openBlock(), _createBlock(_component_UploadModal, { key: 1 }))
                : _createCommentVNode("", true),
              (
                _ctx.role !== 'SALES_LEADER' &&
                _ctx.role !== 'SALES_AREA' &&
                _ctx.role !== 'CS_LEADER' &&
                _ctx.role !== 'CS_MEMBER' &&
                _ctx.role !== 'MARKETING_LEADER' &&
                _ctx.role !== 'MARKETING_MEMBER' &&
                _ctx.role !== 'ADMIN_FINANCE'
              )
                ? (_openBlock(), _createBlock(_component_DaftarPSP, { key: 2 }))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/superadmin/siswa/history-upload'))),
                class: "btn btn-md btn-success"
              }, " History Upload Data "),
              _createVNode(_component_DownloadSekolah)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light",
          style: {"font-weight":"400","margin-top":"0px"},
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showHideFilter && _ctx.showHideFilter(...args)))
        }, " Filter "),
        (_ctx.showFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.schoolId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.schoolId) = $event)),
                  placeholder: "Pilih Sekolah",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listSekolah,
                  searchable: true,
                  label: "name",
                  "track-by": "name",
                  "value-prop": "_id",
                  "max-height": 350,
                  max: 5,
                  style: {"width":"600px"},
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pilihSekolah($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showFilter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Nama",
                    class: "form-control text-center",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.name) = $event)),
                    onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.eventDelaySearch(_ctx.e)))
                  }, null, 544), [
                    [_vModelText, _ctx.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Nomor Identitas",
                    class: "form-control text-center",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.identityNumber) = $event)),
                    onKeyup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.eventDelaySearch(_ctx.e)))
                  }, null, 544), [
                    [_vModelText, _ctx.identityNumber]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Kelas",
                    class: "form-control text-center",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.kelas) = $event)),
                    onKeyup: _cache[10] || (_cache[10] = ($event: any) => (_ctx.eventDelaySearch(_ctx.e)))
                  }, null, 544), [
                    [_vModelText, _ctx.kelas]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Kelas Detail",
                    class: "form-control text-center",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.kelasDetail) = $event)),
                    onKeyup: _cache[12] || (_cache[12] = ($event: any) => (_ctx.eventDelaySearch(_ctx.e)))
                  }, null, 544), [
                    [_vModelText, _ctx.kelasDetail]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.migrationStatus,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.migrationStatus) = $event)),
                    placeholder: "Status",
                    mode: "single",
                    "create-option": false,
                    options: _ctx.comboMigrationStatus,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "_id",
                    onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.pilihMigrationStatus($event)))
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Tag",
                    class: "form-control text-center",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tags) = $event)),
                    onKeyup: _cache[16] || (_cache[16] = ($event: any) => (_ctx.eventDelaySearch(_ctx.e)))
                  }, null, 544), [
                    [_vModelText, _ctx.tags]
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("table", _hoisted_22, [
            _createElementVNode("thead", null, [
              (_ctx.role === 'SALES_LEADER' || _ctx.role === 'SALES_AREA')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, _hoisted_30))
                : (_openBlock(), _createElementBlock("tr", _hoisted_31, _hoisted_39))
            ]),
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_41, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(item.identityNumber), 1),
                      _createElementVNode("td", _hoisted_43, _toDisplayString(item.kelas), 1),
                      _createElementVNode("td", _hoisted_44, _toDisplayString(item.kelasDetail), 1),
                      _createElementVNode("td", _hoisted_45, [
                        (item.migrationStatus == 'ADDED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, " Baru Ditambahkan "))
                          : _createCommentVNode("", true),
                        (item.migrationStatus == 'WAITING PAYMENT')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, " Menunggu Pembayaran "))
                          : _createCommentVNode("", true),
                        (item.migrationStatus == 'ON PROCESS')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, " Proses Daftar PSP "))
                          : _createCommentVNode("", true),
                        (item.migrationStatus == 'FAILED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_49, " Gagal Daftar PSP "))
                          : _createCommentVNode("", true),
                        (item.migrationStatus == 'MIGRATED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, " Sudah Terdaftar PSP "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_51, _toDisplayString(item.tags.join(", ")), 1),
                      _createElementVNode("td", _hoisted_52, [
                        (
                      _ctx.role == 'CS_LEADER' ||
                      _ctx.role == 'CS_MEMBER' ||
                      _ctx.role == 'MARKETING_LEADER' ||
                      _ctx.role == 'MARKETING_MEMBER'
                    )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Detail",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (
                      _ctx.$router.push('/superadmin/siswa/detail/' + item._id)
                    )
                            }, _hoisted_55, 8, _hoisted_53))
                          : _createCommentVNode("", true),
                        (
                      _ctx.role !== 'SALES_LEADER' &&
                      _ctx.role !== 'SALES_AREA' &&
                      _ctx.role !== 'CS_LEADER' &&
                      _ctx.role !== 'CS_MEMBER' &&
                      _ctx.role !== 'MARKETING_LEADER' &&
                      _ctx.role !== 'MARKETING_MEMBER' &&
                      _ctx.role !== 'ADMIN_FINANCE'
                    )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Edit",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.$router.push('/superadmin/siswa/edit/' + item._id))
                            }, _hoisted_58, 8, _hoisted_56))
                          : _createCommentVNode("", true),
                        (
                      item.migrationStatus === 'ADDED' &&
                      _ctx.role !== 'SALES_LEADER' &&
                      _ctx.role !== 'SALES_AREA' &&
                      _ctx.role !== 'CS_LEADER' &&
                      _ctx.role !== 'CS_MEMBER' &&
                      _ctx.role !== 'MARKETING_LEADER' &&
                      _ctx.role !== 'MARKETING_MEMBER' &&
                      _ctx.role !== 'ADMIN_FINANCE'
                    )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Hapus",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.handleDelete(index, item))
                            }, _hoisted_61, 8, _hoisted_59))
                          : _createCommentVNode("", true),
                        (
                      item.migrationStatus !== 'ADDED' &&
                      _ctx.role !== 'SALES_LEADER' &&
                      _ctx.role !== 'SALES_AREA' &&
                      _ctx.role !== 'CS_LEADER' &&
                      _ctx.role !== 'CS_MEMBER' &&
                      _ctx.role !== 'MARKETING_LEADER' &&
                      _ctx.role !== 'MARKETING_MEMBER' &&
                      _ctx.role !== 'ADMIN_FINANCE'
                    )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 3,
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Hapus",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.handleNoDelete(index, item))
                            }, _hoisted_64, 8, _hoisted_62))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_65, _hoisted_67))
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_71))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_72, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("ul", _hoisted_74, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}